import Autolinker from 'autolinker'

/**
 * TODO usage
 *
 * @param date
 * @returns {string}
 */
export const getTodayDate = function(date) {
    const today = moment()
    const inputDate = moment(date)
    let outputDate

    if (today.format('YYYYMMDD') === inputDate.format('YYYYMMDD')) {
        outputDate = `${lang.get('Today')} - `
    } else {
        outputDate = inputDate.format('MMM. D - ')
    }

    outputDate = outputDate + inputDate.format('hh:mma')

    return outputDate
}

/**
 * TODO usage
 *
 * @param amount
 * @param decimalCount
 * @param decimal
 * @param thousands
 * @returns {string}
 */
export const formatNumber = function(amount, decimalCount = 2, decimal = ',', thousands = ' ') {
    try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
        const j = i.length > 3 ? i.length % 3 : 0

        return (
            negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
          ? decimal +
          Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
        )
    } catch (e) {
        console.log(e)
    }
}

/**
 * Creates a file input for a image with preview
 *
 * @param $input
 * @param $preview
 * @param $areaInput
 */
export const fileInputWithPreview = ($input, $preview, $areaInput) => {
    $input = $($input)
    $preview = $($preview)
    $areaInput = $($areaInput)

    $areaInput.click(function() {
        if (!window.User.is_impersonating) {
            $input.click()
        }
    })

    $input.change(() => {
        const reader = new FileReader()

        reader.addEventListener(
            'load',
            () => {
                $preview.attr('src', reader.result)
            },
            false
        )

        const image = $input.get(0).files[0]

        if (image) {
            reader.readAsDataURL(image)
        }
    })
}

/**
 * TODO usage
 *
 * @param index
 * @returns {*}
 */
export const daysInWeek = (index = null) => {
    const startDate = moment().startOf('week')

    const data = window.daysInWeekMap || {}

    if (!window.daysInWeekMap) {
        for (let i = 1; i < 8; i++) {
            data[i] = startDate.clone().add(i - 1, 'day').format('YYYY-MM-DD')
        }

        window.daysInWeekMap = data
    }

    return index ? data[index] : data
}

/**
 * TODO usage
 *
 * @param obj
 * @returns {string}
 */
export const objToQueryString = (obj) => Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&')

export const numberFormat = (amount, decimalCount = 2, decimal = ',', thousands = ' ') => {
    try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        const j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
    } catch (e) {
        console.log(e)
    }
}

/**
 * Utility function used to process a given string of text, and wrap the matches in
 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
 *
 * @param  {String} body
 * @return {String}
 */
export const escapeAndLinkify = (body) => {
    // Converts the characters "&", "<", ">", '"', and "'" in string to their corresponding HTML entities.
    return Autolinker.link(_.escape(body), {
        newWindow: true
    })
}

/**
 * Usage:
 * trim("   Hello   World   ") => 'Hello World'
 */
export const trim = (text) => {
    return _.trim(text).replace(/\s+/g, ' ')
}
